import React from "react";
import ReactDOM from "react-dom/client";
import {
  createHashRouter,
  RouterProvider,
} from "react-router-dom";
import { ConfigProvider, theme } from "antd";
import reportWebVitals from "./reportWebVitals";
import "./i18n/i18n";
import routers from "./router";
import "./index.less";
import "antd/dist/reset.css"; // ⚠️ 必须加
const root = ReactDOM.createRoot(document.getElementById("root"));

const normalizeAmazonLoginRoute = () => {
  const amazonLoginPath = "/amazon-login";

  if (!window.location.pathname.endsWith(amazonLoginPath) || window.location.hash) {
    return;
  }

  const basePath = window.location.pathname.slice(0, -amazonLoginPath.length) || "/";
  const normalizedBasePath = basePath.endsWith("/") ? basePath : `${basePath}/`;

  window.history.replaceState(
    null,
    "",
    `${normalizedBasePath}#${amazonLoginPath}${window.location.search}`
  );
};

normalizeAmazonLoginRoute();

const QIHOOTHEM = {
  token: { borderRadius: 4, },
  algorithm: theme.defaultAlgorithm, // ✅ 正确写法
  components: {
    Layout: {
      siderBg: "#292C30",
      triggerBg: "#292C30",
    },
    Breadcrumb: {
      separatorColor: "#fff",
      linkHoverColor: "#fff",
      linkColor: "#fff",
      itemColor: "#fff",
      lastItemColor: "#fff",
    },
    Slider: {
      dotSize: 28,
      railSize: 16,
      handleActiveColor: "#006BFF",
      dotActiveBorderColor: "#006BFF",
    }
  },
};

const routerArr = createHashRouter(routers);

root.render(
  <ConfigProvider theme={QIHOOTHEM}>
    <RouterProvider router={routerArr} />
  </ConfigProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
